<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 p-4">
        <div class="card">
          <div class="card-body">
            <!-- Certificate watermark -->
            <h1 style="text-transform: uppercase; font-size: 137px; position: absolute; transform: rotate(45deg); top: 63%; opacity: 10%; font-weight: 700; color: green; font-family: 'Pridi', serif; left: 13%;">{{certificateData.transferReference}}</h1>

            <!-- Certificate header -->
            <div class="row mb-4">
              <div class="col-12 text-center">
                <div style="display: flex; height: 47mm; align-items: center; position: relative; width: 100%; justify-content: space-between; padding: 8mm;">
                  <div>
                    <img :src="state_logo()" style="height: 36mm; margin-right: 0mm;">
                  </div>
                  <div style="text-align: center; margin-right: 8.5mm; margin-left: 8.5mm;">
                    <h2 style="margin-top: 0px; font-size: 26px; text-transform: uppercase; color: #00582f; font-weight: 700; margin-bottom: 1.2mm; padding-bottom: 0px;">
                      County Government Of {{county.countyName}}
                    </h2>
                    <h4 style="padding: 0px; margin: 0px; font-size: 18px; font-weight: bold; text-transform: uppercase; margin-bottom: 4.5mm;">
                      {{certificateData.subCountyName}}
                    </h4>
                    <h4 style="padding: 0px; margin: 0px; font-size: 14px; font-weight:500;">
                      {{county.address}} <br>
                      Email: {{county.email}}
                    </h4>
                    <h4 style="padding: 0px; margin: 0px; font-size: 13px; font-weight: 500; font-style: italic; font-family: 'Times New Roman', Times, serif; margin-top: 2mm;">
                      <span style="font-style: italic; font-family: 'Times New Roman', Times, serif; margin-right: 3mm;">{{county.tagline2}}</span>
                    </h4>
                  </div>
                  <div>
                    <img :src="county_logo()" style="height: 36mm; margin-right: 0mm;">
                  </div>
                </div>
                <div class="cert-heading my-3" style="padding-top: 0px !important; margin-top: 0.2in !important; text-align: center; display: flex; flex-flow: column; align-items: center; justify-content: center;">
                  <h6 style="margin-top: 0px; padding-top: 0px; font-size: 18px; font-weight: 400; font-family:'Pridi', serif !important; margin-bottom: 0.2in; padding-bottom: 0px; text-transform: uppercase;">
                    Property Transfers Registry <br>
                    The {{county.countyName}} County Land Transfer and Registration Act
                  </h6>
                  <h1 style="font-family: 'Fondamento', cursive !important; font-size: 55px; margin: 0px; padding: 0px; width: 200mm; margin-top: 5mm; margin-bottom: 5mm;">
                    <strong style="font-family: 'Fondamento', cursive !important;">Property Transfer Certificate</strong>
                  </h1>
                  <p class="text-muted">Transfer Reference: {{ certificateData.transferReference }}</p>
                </div>
              </div>
            </div>

            <!-- Property details -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="border p-3 rounded">
                  <h5 class="text-uppercase border-bottom pb-2 mb-3">Property Details</h5>
                  <div class="row">
                    <div class="col-md-4 mb-3">
                      <p class="mb-1 text-muted">LR Number:</p>
                      <p class="fw-bold">{{ certificateData.propertyLRNumber }}</p>
                    </div>
                    <div class="col-md-4 mb-3">
                      <p class="mb-1 text-muted">Zone/Block:</p>
                      <p class="fw-bold">{{ certificateData.zone }} / {{ certificateData.block }}</p>
                    </div>
                    <div class="col-md-4 mb-3">
                      <p class="mb-1 text-muted">Location:</p>
                      <p class="fw-bold">{{ certificateData.percelAddress }}</p>
                    </div>
                    <div class="col-md-4 mb-3">
                      <p class="mb-1 text-muted">Sub County:</p>
                      <p class="fw-bold">{{ certificateData.subCountyName }}</p>
                    </div>
                    <div class="col-md-4 mb-3">
                      <p class="mb-1 text-muted">Ward:</p>
                      <p class="fw-bold">{{ certificateData.wardName }}</p>
                    </div>
                    <div class="col-md-4 mb-3">
                      <p class="mb-1 text-muted">Parcel Size:</p>
                      <p class="fw-bold">{{ certificateData.percelSize }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Transfer details -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="border p-3 rounded">
                  <h5 class="text-uppercase border-bottom pb-2 mb-3">Transfer Information</h5>
                  <div class="row">
                    <div class="col-md-4 mb-3">
                      <p class="mb-1 text-muted">Transfer Type:</p>
                      <p class="fw-bold">{{ certificateData.transferType }}</p>
                    </div>
                    <div class="col-md-4 mb-3">
                      <p class="mb-1 text-muted">Transfer Date:</p>
                      <p class="fw-bold">{{ formatDate(certificateData.transferDate) }}</p>
                    </div>
                    <div class="col-md-4 mb-3">
                      <p class="mb-1 text-muted">Certificate Date:</p>
                      <p class="fw-bold">{{ formatDate(new Date()) }}</p>
                    </div>
                    <div class="col-md-4 mb-3">
                      <p class="mb-1 text-muted">Transfer Reference No:</p>
                      <p class="fw-bold">{{ certificateData.transferReference }}</p>
                    </div>
                    <div class="col-md-8 mb-3">
                      <p class="mb-1 text-muted">Transfer Reason/Notes:</p>
                      <p class="fw-bold">{{ certificateData.transferNotes || 'N/A' }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ownership transfer -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="border p-3 rounded">
                  <h5 class="text-uppercase border-bottom pb-2 mb-3">Ownership Transfer</h5>
                  <div class="row">
                    <div class="col-md-6">
                      <h6 class="text-uppercase text-primary mb-3">From (Previous Owner)</h6>
                      <div class="mb-3">
                        <p class="mb-1 text-muted">Name:</p>
                        <p class="fw-bold">{{ certificateData.oldOwnerName }}</p>
                      </div>
                      <div class="mb-3">
                        <p class="mb-1 text-muted">ID/Registration No:</p>
                        <p class="fw-bold">{{ certificateData.oldOwnerID || 'N/A' }}</p>
                      </div>
                      <div class="mb-3">
                        <p class="mb-1 text-muted">Contact:</p>
                        <p class="fw-bold">{{ certificateData.oldOwnerPhone || 'N/A' }}</p>
                      </div>
                      <div class="mb-3">
                        <p class="mb-1 text-muted">Email:</p>
                        <p class="fw-bold">{{ certificateData.oldOwnerEmail || 'N/A' }}</p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <h6 class="text-uppercase text-success mb-3">To (New Owner)</h6>
                      <div class="mb-3">
                        <p class="mb-1 text-muted">Name:</p>
                        <p class="fw-bold">{{ certificateData.newOwnerName }}</p>
                      </div>
                      <div class="mb-3">
                        <p class="mb-1 text-muted">ID/Registration No:</p>
                        <p class="fw-bold">{{ certificateData.newOwnerID || 'N/A' }}</p>
                      </div>
                      <div class="mb-3">
                        <p class="mb-1 text-muted">Contact:</p>
                        <p class="fw-bold">{{ certificateData.newOwnerPhone || 'N/A' }}</p>
                      </div>
                      <div class="mb-3">
                        <p class="mb-1 text-muted">Email:</p>
                        <p class="fw-bold">{{ certificateData.newOwnerEmail || 'N/A' }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Property status -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="border p-3 rounded">
                  <h5 class="text-uppercase border-bottom pb-2 mb-3">Financial Status</h5>
                  <div class="row">
                    <div class="col-md-4 mb-3">
                      <p class="mb-1 text-muted">Annual Charges:</p>
                      <p class="fw-bold">KES {{ numberFormat(certificateData.annualCharges || 0) }}</p>
                    </div>
                    <div class="col-md-4 mb-3">
                      <p class="mb-1 text-muted">Outstanding Arrears at Transfer:</p>
                      <p class="fw-bold">KES {{ numberFormat(certificateData.outstandingArrears || 0) }}</p>
                    </div>
                    <div class="col-md-4 mb-3">
                      <p class="mb-1 text-muted">Arrears Transferred:</p>
                      <p class="fw-bold">{{ certificateData.arrearsTransferred ? 'Yes' : 'No' }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Decorative element -->
            <div class="col-12 text-center mb-4">
              <img src="./assets/ornament.svg" style="width: 170px; margin-bottom: 0.2in; margin-top: 0.2in;" />
            </div>

            <!-- Certification -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="border p-3 rounded">
                  <p class="mb-3">
                    This is to certify that the above-mentioned property has been duly transferred from
                    <strong>{{ certificateData.oldOwnerName }}</strong> to <strong>{{ certificateData.newOwnerName }}</strong>
                    on <strong>{{ formatDate(certificateData.transferDate) }}</strong> in accordance with the applicable laws
                    and regulations of the county government.
                  </p>

                  <div class="row mt-5">
                    <div class="col-md-4 text-center mb-4">
                      <div class="border-top w-75 mx-auto pt-2">
                        <p class="mb-0">County Land Registrar</p>
                      </div>
                    </div>
                    <div class="col-md-4 text-center mb-4">
                      <div>
                        <img :src="sealImage" style="height: 160px;" >
                      </div>
                    </div>
                    <div class="col-md-4 text-center mb-4">
                      <div>
                        <img :src="signatureImage" alt="The signature" class="the-stamp" style="height: 14mm;">
                      </div>
                      <div class="border-top w-75 mx-auto pt-2">
                        <p class="mb-0">Transferred By</p>
                        <p class="fw-bold mt-2">{{ certificateData.transferredBy || '-' }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Supporting Documents -->
            <div class="row mb-4" v-if="documents && documents.length > 0">
              <div class="col-12">
                <div class="border p-3 rounded">
                  <h5 class="text-uppercase border-bottom pb-2 mb-3">Supporting Documents</h5>
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead class="table-light">
                      <tr>
                        <th>#</th>
                        <th>Document Name</th>
                        <th>Uploaded Date</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(doc, index) in documents" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ doc.file_name }}</td>
                        <td>{{ formatDate(doc.uploaded_date) }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer -->
            <div style="position: relative; bottom: 10mm; padding-right: 5mm; padding-left: 2mm;">
              <div>
                <div style="display: flex; justify-content: space-between; align-items:center; font-size: 12px; font-weight: 500;">
                  <span>Permit No.: <span style="font-weight: bold; color: red;">{{certificateData.transferReference}}</span></span>
                  <span>Date Downloaded {{currentDate()}}</span>
                </div>
                <img src="./assets/green-line.png" style="width: 100%;">
              </div>
              <div class="col-12" style="font-size: 12px; padding: 0px; margin: 0px;">
                <h4 style="text-transform: uppercase;">County Government of {{county.countyName}}</h4>
                <p class="red font-14" style="font-weight: 500; font-size: 12px !important;">
                  Notice: Any alterations to this certificate after issuance shall render it invalid. The property transfer details are maintained in the county registry.
                </p>
              </div>
            </div>

            <!-- Print button -->
            <div class="row">
              <div class="col-12 text-center">
                <button @click="printCertificate" class="btn btn-primary btn-lg">
                  <i class="mdi mdi-printer me-1"></i> Print Certificate
                </button>
                <button @click="goBack" class="btn btn-secondary btn-lg ms-3">
                  <i class="mdi mdi-arrow-left me-1"></i> Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {execute, landRate, county_logo, state_logo, authUrl} from "@/api";

export default {
  name: "TransferCertificate",
  data() {
    return {
      sealImage: './assets/seal-transfer.png',
      signatureImage: './assets/signature-transfer.png',
      certificateData: {
        transferReference: '',
        propertyLRNumber: '',
        zone: '',
        block: '',
        percelAddress: '',
        subCountyName: '',
        wardName: '',
        percelSize: '',
        oldOwnerName: '',
        oldOwnerID: '',
        oldOwnerPhone: '',
        oldOwnerEmail: '',
        newOwnerName: '',
        newOwnerID: '',
        newOwnerPhone: '',
        newOwnerEmail: '',
        transferDate: '',
        transferType: '',
        transferNotes: '',
        annualCharges: 0,
        outstandingArrears: 0,
        arrearsTransferred: true,
        transferredBy: ''
      },
      documents: [],
      county: {}
    };
  },
  mounted() {
    this.getCounty()
    // Get data from localStorage
    const transferParams = localStorage.getItem('transferParams');
    if (transferParams) {
      const params = JSON.parse(transferParams);
      this.certificateData = {
        ...this.certificateData,
        ...params
      };

      // Fetch additional details if needed
      this.fetchCertificateDetails();
    }
  },
  methods: {

    getCounty(){
      const data = new FormData();
      data.append("function", "getCounty");
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.county = res.data.data.county
            }else{
              // alert(res.data.message)
            }
          })
          .catch((e) => {
            //alert(e.message);
            this.message =e.message
          });
    },

    county_logo() {
      return county_logo;
    },
    state_logo() {
      return state_logo;
    },
    formatDate(date) {
      if (!date) return 'N/A';

      const d = new Date(date);
      const day = d.getDate();
      const month = d.toLocaleString('default', { month: 'long' });
      const year = d.getFullYear();

      let suffix = 'th';
      if (day % 10 === 1 && day !== 11) {
        suffix = 'st';
      } else if (day % 10 === 2 && day !== 12) {
        suffix = 'nd';
      } else if (day % 10 === 3 && day !== 13) {
        suffix = 'rd';
      }

      return `${day}${suffix} ${month}, ${year}`;
    },

    currentDate() {
      const date = new Date();
      const day = date.getDate();
      const month = date.getMonth();
      const year = date.getFullYear();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const suffix = hour >= 12 ? "PM" : "AM";
      const formattedHour = hour % 12 || 12;
      const formattedDay = day < 10 ? "0" + day : day;
      const formattedMinute = minute < 10 ? "0" + minute : minute;
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const monthName = months[month];
      return `${formattedDay} ${monthName} ${year} ${formattedHour}:${formattedMinute} ${suffix}`;
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },

    fetchCertificateDetails() {
      if (!this.certificateData.transferReference) return;

      const data = new FormData();
      data.append("function", "getTransferCertificate");
      data.append("transferReference", this.certificateData.transferReference);

      // Call API to get certificate details
      execute(data, landRate)
          .then((res) => {
            if (res.data.success) {
              if (res.data.data.certificate) {
                // Merge with existing data
                this.certificateData = {
                  ...this.certificateData,
                  zone: res.data.data.certificate.zone || this.certificateData.zone,
                  block: res.data.data.certificate.block || this.certificateData.block,
                  percelAddress: res.data.data.certificate.percelAddress || this.certificateData.percelAddress,
                  subCountyName: res.data.data.certificate.subCountyName || this.certificateData.subCountyName,
                  wardName: res.data.data.certificate.wardName || this.certificateData.wardName,
                  percelSize: res.data.data.certificate.percelSize || this.certificateData.percelSize,
                  annualCharges: res.data.data.certificate.annualCharges || 0,
                  outstandingArrears: res.data.data.certificate.outstandingArrears || 0,
                  transferredBy: res.data.data.certificate.transferred_by || this.certificateData.transferredBy,
                  oldOwnerID: res.data.data.certificate.previous_owner_id || this.certificateData.oldOwnerID,
                  oldOwnerPhone: res.data.data.certificate.previous_owner_phone || this.certificateData.oldOwnerPhone,
                  oldOwnerEmail: res.data.data.certificate.previous_owner_email || this.certificateData.oldOwnerEmail,
                  newOwnerID: res.data.data.certificate.new_owner_id || this.certificateData.newOwnerID,
                  newOwnerPhone: res.data.data.certificate.new_owner_phone || this.certificateData.newOwnerPhone,
                  newOwnerEmail: res.data.data.certificate.new_owner_email || this.certificateData.newOwnerEmail,
                  transferNotes: res.data.data.certificate.transfer_notes || this.certificateData.transferNotes
                };
              }

              if (res.data.data.documents) {
                this.documents = res.data.data.documents;
              }
            }
          })
          .catch((e) => {
            console.error("Error fetching certificate details:", e);
          });
    },

    printCertificate() {
      window.print();
    },

    goBack() {
      this.$router.push('/land-rates');
    }
  }
};
</script>

<style scoped>
@media print {
  button, .btn {
    display: none !important;
  }

  .card {
    border: none !important;
    box-shadow: none !important;
  }

  .card-body {
    padding: 0 !important;
  }

  @page {
    size: A4;
    margin: 1cm;
  }
}

/* Additional styling */
.text-muted {
  color: #6c757d !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.text-primary {
  color: #007bff !important;
}

.text-success {
  color: #28a745 !important;
}

.red {
  color: red !important;
}

/* Elegent border style for the sections */
.border {
  border: 1px solid rgba(0, 105, 62, 0.2) !important;
}

.border-top {
  border-top: 1px solid rgba(0, 105, 62, 0.4) !important;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 105, 62, 0.2) !important;
}

.rounded {
  border-radius: 0.35rem !important;
}

/* Header stylings */
h5 {
  color: #00582f;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1.1rem;
}

h6 {
  font-weight: 600;
  font-size: 0.95rem;
}
</style>